<script>
    import { fly } from "svelte/transition";
    import { Tabs, Tab } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Tabs>
            <Tab title="水果">菠萝</Tab>
            <Tab title="番茄" >蔬菜</Tab>
            <Tab title="谷类" >小米</Tab>
        </Tabs>
    </div>
    <h4 class="example-title">超长自动滚动</h4>
    <div class="example-body">
        <Tabs>
            <Tab title="Espresso">1</Tab>
            <Tab title="Coffee Latte" >2</Tab>
            <Tab title="Cappuccino" >3</Tab>
            <Tab title="Americano" >4</Tab>
            <Tab title="Flat White" >5</Tab>
            <Tab title="Caramel Macchiato" >6</Tab>
        </Tabs>
    </div>
    <h4 class="example-title">没有内容区</h4>
    <div class="example-body">
        <Tabs on:change={(e)=>console.log(e.detail)}>
            <Tab title="水果"></Tab>
            <Tab title="番茄"></Tab>
            <Tab title="谷类"></Tab>
        </Tabs>
    </div>
    <h4 class="example-title">禁用状态</h4>
    <div class="example-body">
        <Tabs on:change={(e)=>console.log(e.detail)}>
            <Tab title="水果">1</Tab>
            <Tab title="番茄">2</Tab>
            <Tab title="谷类" disabled>3</Tab>
        </Tabs>
    </div>
    <h4 class="example-title">自定义字体大小</h4>
    <div class="example-body">
        <Tabs on:change={(e)=>console.log(e.detail)} --title-font-size="12">
            <Tab title="水果">菠萝</Tab>
            <Tab title="番茄" >蔬菜</Tab>
            <Tab title="谷类" >小米</Tab>
        </Tabs>
    </div>
    <h4 class="example-title">胶囊Tab</h4>
    <div class="example-body nopadding">
        <Tabs capsule={true} on:change={(e)=>console.log(e.detail)}>
            <Tab title="水果">菠萝</Tab>
            <Tab title="番茄" >蔬菜</Tab>
            <Tab title="谷类" >小米</Tab>
        </Tabs>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .nopadding {
        padding: 0;
    }
</style>
